/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as MapRouteImport } from './routes/_map';
import { Route as MapIndexRouteImport } from './routes/_map/index';
import { Route as MapSidebarRouteImport } from './routes/_map/_sidebar';
import { Route as MapSidebarContactRouteImport } from './routes/_map/_sidebar/contact';
import { Route as MapSidebarImprintRouteImport } from './routes/_map/_sidebar/imprint';
import { Route as MapSidebarInfoRouteImport } from './routes/_map/_sidebar/info';
import { Route as MapSidebarLegalRouteImport } from './routes/_map/_sidebar/legal';
import { Route as MapSidebarRouteIndexRouteImport } from './routes/_map/_sidebar/route/index';

const MapRoute = MapRouteImport.update({
  id: '/_map',
  getParentRoute: () => rootRouteImport,
} as any);
const MapIndexRoute = MapIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MapRoute,
} as any);
const MapSidebarRoute = MapSidebarRouteImport.update({
  id: '/_sidebar',
  getParentRoute: () => MapRoute,
} as any);
const MapSidebarContactRoute = MapSidebarContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => MapSidebarRoute,
} as any);
const MapSidebarImprintRoute = MapSidebarImprintRouteImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => MapSidebarRoute,
} as any);
const MapSidebarInfoRoute = MapSidebarInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => MapSidebarRoute,
} as any);
const MapSidebarLegalRoute = MapSidebarLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => MapSidebarRoute,
} as any);
const MapSidebarRouteIndexRoute = MapSidebarRouteIndexRouteImport.update({
  id: '/route/',
  path: '/route/',
  getParentRoute: () => MapSidebarRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof MapIndexRoute;
  '/contact': typeof MapSidebarContactRoute;
  '/imprint': typeof MapSidebarImprintRoute;
  '/info': typeof MapSidebarInfoRoute;
  '/legal': typeof MapSidebarLegalRoute;
  '/route/': typeof MapSidebarRouteIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof MapIndexRoute;
  '/contact': typeof MapSidebarContactRoute;
  '/imprint': typeof MapSidebarImprintRoute;
  '/info': typeof MapSidebarInfoRoute;
  '/legal': typeof MapSidebarLegalRoute;
  '/route': typeof MapSidebarRouteIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_map': typeof MapRouteWithChildren;
  '/_map/_sidebar': typeof MapSidebarRouteWithChildren;
  '/_map/': typeof MapIndexRoute;
  '/_map/_sidebar/contact': typeof MapSidebarContactRoute;
  '/_map/_sidebar/imprint': typeof MapSidebarImprintRoute;
  '/_map/_sidebar/info': typeof MapSidebarInfoRoute;
  '/_map/_sidebar/legal': typeof MapSidebarLegalRoute;
  '/_map/_sidebar/route/': typeof MapSidebarRouteIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: '/' | '/contact' | '/imprint' | '/info' | '/legal' | '/route/';
  fileRoutesByTo: FileRoutesByTo;
  to: '/' | '/contact' | '/imprint' | '/info' | '/legal' | '/route';
  id:
    | '__root__'
    | '/_map'
    | '/_map/_sidebar'
    | '/_map/'
    | '/_map/_sidebar/contact'
    | '/_map/_sidebar/imprint'
    | '/_map/_sidebar/info'
    | '/_map/_sidebar/legal'
    | '/_map/_sidebar/route/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  MapRoute: typeof MapRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_map': {
      id: '/_map';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof MapRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_map/': {
      id: '/_map/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof MapIndexRouteImport;
      parentRoute: typeof MapRoute;
    };
    '/_map/_sidebar': {
      id: '/_map/_sidebar';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof MapSidebarRouteImport;
      parentRoute: typeof MapRoute;
    };
    '/_map/_sidebar/contact': {
      id: '/_map/_sidebar/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof MapSidebarContactRouteImport;
      parentRoute: typeof MapSidebarRoute;
    };
    '/_map/_sidebar/imprint': {
      id: '/_map/_sidebar/imprint';
      path: '/imprint';
      fullPath: '/imprint';
      preLoaderRoute: typeof MapSidebarImprintRouteImport;
      parentRoute: typeof MapSidebarRoute;
    };
    '/_map/_sidebar/info': {
      id: '/_map/_sidebar/info';
      path: '/info';
      fullPath: '/info';
      preLoaderRoute: typeof MapSidebarInfoRouteImport;
      parentRoute: typeof MapSidebarRoute;
    };
    '/_map/_sidebar/legal': {
      id: '/_map/_sidebar/legal';
      path: '/legal';
      fullPath: '/legal';
      preLoaderRoute: typeof MapSidebarLegalRouteImport;
      parentRoute: typeof MapSidebarRoute;
    };
    '/_map/_sidebar/route/': {
      id: '/_map/_sidebar/route/';
      path: '/route';
      fullPath: '/route/';
      preLoaderRoute: typeof MapSidebarRouteIndexRouteImport;
      parentRoute: typeof MapSidebarRoute;
    };
  }
}

interface MapSidebarRouteChildren {
  MapSidebarContactRoute: typeof MapSidebarContactRoute;
  MapSidebarImprintRoute: typeof MapSidebarImprintRoute;
  MapSidebarInfoRoute: typeof MapSidebarInfoRoute;
  MapSidebarLegalRoute: typeof MapSidebarLegalRoute;
  MapSidebarRouteIndexRoute: typeof MapSidebarRouteIndexRoute;
}

const MapSidebarRouteChildren: MapSidebarRouteChildren = {
  MapSidebarContactRoute: MapSidebarContactRoute,
  MapSidebarImprintRoute: MapSidebarImprintRoute,
  MapSidebarInfoRoute: MapSidebarInfoRoute,
  MapSidebarLegalRoute: MapSidebarLegalRoute,
  MapSidebarRouteIndexRoute: MapSidebarRouteIndexRoute,
};

const MapSidebarRouteWithChildren = MapSidebarRoute._addFileChildren(
  MapSidebarRouteChildren,
);

interface MapRouteChildren {
  MapSidebarRoute: typeof MapSidebarRouteWithChildren;
  MapIndexRoute: typeof MapIndexRoute;
}

const MapRouteChildren: MapRouteChildren = {
  MapSidebarRoute: MapSidebarRouteWithChildren,
  MapIndexRoute: MapIndexRoute,
};

const MapRouteWithChildren = MapRoute._addFileChildren(MapRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  MapRoute: MapRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
